<template>
  <Menu v-if="options" as="div" class="inline-block relative flex-4">
    <MenuButton
      class="h-full inline-flex w-full border border-1 border-divider items-center justify-center bg-background rounded-md space-x-2 py-2 px-4 font-bold shadow-sm hover:outline hover:outline-1 hover:outline-primary">
      <span class="text-foreground">ID</span>
      <MdArrowDropdownIcon w="25px" h="25px" class="fill-foreground" />
    </MenuButton>

    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <MenuItems
        class="mt-2 absolute right-0 z-10 w-full origin-top-right bg-background text-foreground rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
        <div class="py-1">
          <MenuItem v-for="option in options" :key="option.id">
          <a class="block px-4 py-2 text-sm hover:bg-hover hover:cursor-pointer" @click="selectedOption(option)">
            {{ option }}
          </a>
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </Menu>
  <div class="flex gap-4" v-else>
    <input
      class="rounded-md px-4 py-2 bg-background text-foreground font-medium w-40 border border-1 border-divider hover:outline hover:outline-2 focus:outline-2 hover:outline-primary focus:outline-primary"
      placeholder="Enter NFT ID..." type="number" min="0" maxlength="5" v-model="number" @input="restrictInput" />
    <button
      class="py-2 px-4 rounded-md font-bold bg-primary text-white hover:bg-primaryDark hover:border-outline focus:outline-none focus:ring-1 focus:ring-primary focus:ring-offset-2"
      @click="submitOption()">
      Submit
    </button>
  </div>
</template>
<script>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import MdArrowDropdownIcon from "vue-ionicons/dist/md-arrow-dropdown.vue";
import store from "@/store";
import { useToast } from "vue-toastification";

export default {
  components: { Menu, MenuButton, MenuItem, MenuItems, MdArrowDropdownIcon },
  computed: {
    options() {
      if (store.state.nfts) {
        const result = store.state.nfts
          .filter(
            (o) =>
              o.tokenAddress._value ===
              "0x364c828ee171616a39897688a831c2499ad972ec" ||
              o.tokenAddress._value ===
              "0x1C70D0A86475CC707b48aA79F112857e7957274f"
          )
          .map((o) => o.tokenId);

        return result.length ? result : null;
      }

      return null;
    },
  },
  data() {
    return { number: "" };
  },
  methods: {
    async selectedOption(item) {
      store.dispatch("GetMemePreviews", item);
    },
    async submitOption() {
      if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 63, 2093, 4920, 5403, 6666, 6969, 9950].includes(Number(this.number))) {
        let toast = useToast();
        toast.info("Coming soon.....", {
          timeout: 1400,
        })
        store.dispatch("GetMemePreviews", Number(this.number));
        return;
      }
      if (this.number) {
        store.dispatch("GetMemePreviews", this.number);
        let toast = useToast();
        toast.warning("Loading...", {
          timeout: 2500,
        });
        localStorage.setItem("preferredId", this.number);
      }
    },
    restrictInput(event) {
      const input = event.target;
      if (input.value.length > input.maxLength) {
        input.value = input.value.slice(0, input.maxLength);
      }
      if (input.value < 0) {
        input.value = 0;
      }
      if (input.value > 10000) {
        input.value = 10000;
      }
    },
  },
};
</script>
